export interface GeofenceCenter {
	latitude: number;
	longitude: number;
}

export interface Geofence {
	id: string;
	name?: string;
	enabled: boolean;
	center: GeofenceCenter | null;
	radiusMeters: number;
}

const EARTH_RADIUS_METERS = 6371000;

export function getDistanceInMeters(
	firstLatitude: number,
	firstLongitude: number,
	secondLatitude: number,
	secondLongitude: number,
) {
	const lat1 = (firstLatitude * Math.PI) / 180;
	const lat2 = (secondLatitude * Math.PI) / 180;
	const deltaLat = ((secondLatitude - firstLatitude) * Math.PI) / 180;
	const deltaLng = ((secondLongitude - firstLongitude) * Math.PI) / 180;

	const a =
		Math.sin(deltaLat / 2) ** 2 +
		Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) ** 2;

	return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(a));
}

export function isPointInsideGeofence(
	latitude: number,
	longitude: number,
	geofence: Geofence,
) {
	if (!geofence.enabled || !geofence.center) {
		return false;
	}

	if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
		return false;
	}

	return (
		getDistanceInMeters(
			latitude,
			longitude,
			geofence.center.latitude,
			geofence.center.longitude,
		) <= geofence.radiusMeters
	);
}
